import React, { useMemo } from "react";
import { faDrawCircle } from "web-fortawesome/npm/pro-light";
import { faDrawCircle as faDrawCircleSolid } from "web-fortawesome/npm/pro-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IPresenceIconProps } from "./IPresenceIconProps";

/**
 * Presence Icon: Meetings
 * @param props - props from interface IPresenceIconProps
 * @returns - the meetings icon
 */
export const PresenceIconMeetings = (props: IPresenceIconProps): React.ReactElement => {
	const icon = useMemo(() => {
		if (!props.callProtection && !props.lineForwarded) {
			if (props.type === "busy")
				return faDrawCircleSolid;
			else
				return faDrawCircle;
		}
		return faDrawCircle;
	}, [props.type, props.callProtection, props.lineForwarded]);

	return (
		<FontAwesomeIcon
			className={props.className}
			icon={icon}
			transform={{ rotate: 45 }}
			fontSize={props.fontSize ?? 16}
			color={props.color ? props.color : `var(--presence-icon-type-${props.type ?? "free"})`}
		/>
	);
};
